module.exports = __webpack_public_path__ + "img/pic_number_90_black.88607920.png";